var App = App || {};

App.WidgetForm = (function ($) {
    'use strict';

    function decorateSubmitButton(form) {
        form.find("input[type='submit'].js-form-submit-with-icon").each(function () {
            const $input = $(this);
            const buttonText = $input.val() || "Submit";
            const classes = $input.attr("class") || "";

            const $button = $(`
                <button type="submit" class="${classes}">
                    <span>${buttonText}</span>
                </button>
            `);

            $input.replaceWith($button);
        });
    }

    function fixGroupLabelForAttributes(form) {
        // ADA fix: for checkbox/radio groups (<fieldset><legend>), the group <label> inside the
        // <legend> must not have a `for` pointing to a non-existent element. Kentico's
        // MultipleChoiceComponent generates `for="..._SelectedValues"` which has no matching
        // element in the DOM. The <legend> itself already provides the accessible group name,
        // so we safely remove the invalid `for` attribute.
        form.find('fieldset legend label[for]').each(function () {
            const $label = $(this);
            if (!document.getElementById($label.attr('for'))) {
                $label.removeAttr('for');
            }
        });
    }

    function Init(selector) {
        const form = selector.find("form");

        decorateSubmitButton(form);
        fixGroupLabelForAttributes(form);
        form
            .find(".ktc-uploader-text-button")
            .attr("href", "#")
            .on("click", function (e) { e.preventDefault(); });
        if (form.is("[data-zag-validate-form]")) {
            App.SharedFormValidation.Init(form);
        }
    }

    return {
        Init: Init
    };

})(jQuery);
